import get from 'lodash.get';

export const getMappedContentType = (props) => {
  const contentType = get(props, 'layoutData.page.contentType', '');

  switch (contentType) {
    case 'HOMEPAGE':
      return 'home';
    case 'BASIC_PAGE':
      return 'page';
    case 'REVIEW':
      return 'review';
    case 'PAGINATED_REVIEW':
      return 'review';
    case 'PAGINATED_REVIEW_VERDICT':
      return 'review';
    case 'OWNER_REVIEW':
      return 'review';
    case 'SEARCH_INDEX':
      return '';
    case 'INDEX_PAGE':
      return 'index';
    case 'TAXONOMY_INDEX':
      return 'index';
    case 'WHITEPAPER':
      return 'resource-download';
    case 'GALLERY':
      return 'gallery';
    case 'VEHICLE_SPECLIST':
    case 'VEHICLE_SPECS':
      return 'spec';
    case 'ARTICLE':
    case 'NEWS':
    case 'BESTS':
    default:
      return 'article';
  }
};

export const getMappedLayoutType = (props) => {
  const layoutType = get(props, 'layoutData.page.layoutType', '');

  switch (layoutType) {
    case 'Full Width':
      return 'fullWidth';
    case 'Default':
      return 'default';
    case 'Landing Page':
    case 'landingPage':
      return 'landingPage';
    case 'Commercial Page':
    case 'commercialPage':
      return 'commercialPage';
    case 'Commercial Page Title Image':
    case 'commercialPageTitleImage':
      return 'commercialPageTitleImage';
    default:
      return 'default';
  }
};
